export const currencySignsObj = {
    'usd': '$',
    'eur': '€',
    'euro': '€',
    'shekel': '₪',
    'ILS': '₪',
};